import { render, staticRenderFns } from "./Datasets.vue?vue&type=template&id=24ce1e20&"
import script from "./Datasets.vue?vue&type=script&lang=js&"
export * from "./Datasets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports